import { render } from "./TotalStudentWrap.vue?vue&type=template&id=0462be49"
import script from "./TotalStudentWrap.vue?vue&type=script&lang=js"
export * from "./TotalStudentWrap.vue?vue&type=script&lang=js"

import "./TotalStudentWrap.vue?vue&type=style&index=0&id=0462be49&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__